/**
 * LOADING STATE
 * Composant réutilisable pour afficher un état de chargement
 * Remplace les 30 lignes dupliquées dans chaque page
 */

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = 'Chargement...' }: LoadingStateProps) {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="flex flex-col items-center gap-3">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-zinc-900" />
        <p className="text-sm text-zinc-500">{message}</p>
      </div>
    </div>
  );
}
